/*
 * @Author: lyx
 * @Date: 2024-08-13 10:25:17
 * @LastEditors: lyx
 * @LastEditTime: 2024-08-13 11:14:04
 * @FilePath: /dbrank_b/src/routes/visualChart/P28/chart.js
 */

import { labelFont, xAxisLabelColor, yAxisLabelColor } from "../visualConfig";
import { toVisualThousands } from "../utils";


export default ({chartAxis, chartList = [], color = [] }) => {
  console.log('chartAxis',chartAxis);
  console.log('chartList',chartList);
  console.log('color',color);
  return {
    title: {
       text: '内容篇数分布（单位：条）',
       align: 'left'
    },
    color,
    legend: {
      show: true,
      top: 'middle',
      top: 0,
      right: 0,
      orient: 'vertical',
      itemWidth: 8,
      itemHeight: 8,
      textStyle: {
        fontSize: 16,
        fontWeight: 'bold',
        color: '#000',
      }
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    grid: {
      left: 20,
      right: 0,
      bottom: 70,
      containLabel: true
    },
    xAxis: {
      show: true,
      type: 'category',
      data: chartAxis.map((item,index) => {
        return item+'内容'
      }),
      inverse: true,
      axisTick: {show: false},
      axisLine: {
        show: true,
        lineStyle: {
          color: '#ccc'
        }
      },
      axisLabel: { 
        ...xAxisLabelColor, 
        fontSize: 22, 
        fontWeight: 'bold',
        color: '#000',
        padding: [10,0,0,0]
      },
    },
    yAxis: {
      nameTextStyle: {
        fontSize: 18,
        fontWeight: 'bold',
        color: '#000',
        align: 'left'
      },
      type: 'value',
      splitLine: { show: false },
      axisLabel: {
         ...yAxisLabelColor,
         fontSize: 16,

      },
    },
    series: chartList.map((item, i) => {
      const itemStyle = { color: color[i] };
      return {
        name: item.name,
        type: 'bar',
        barGap: '20%',
        barWidth: 30,
        label: {
          show: true,
          position: 'top',
          formatter: (ele) => toVisualThousands(ele.value),
          ...labelFont,
        },
        data: item.list.map(val => ({
          value: val,
          itemStyle,
          emphasis: { itemStyle },
        })),
      }
    })
  };
};



// WEBPACK FOOTER //
// src/routes/visualChart/P32/chart.js